
	frappe.templates['sidebar_header'] = `<a class="sidebar-header shell-header" style="text-decoration: none;">
<div class="header-logo">{%= header_icon %}</div>
<div class="title-container">
    <div class="sidebar-item-label header-title" data-name-style="{%=frappe.boot.app_name_style%}">
            {%= __(workspace_title) %}
    </div>
</div>
<button class="btn-reset drop-icon" aria-label="{%= __('Sidebar Menu') %}">
    {%= frappe.utils.icon("chevron-down", "sm", "", "", "", true) %}
</button>
</a>
`;
